import {
  MatchObjType,
  relatedAddGetTypes,
  relatedStartTimeTypes,
  Shmoment
} from './types';
import { DAY_FULL_NAMES, MONTH_NAMES, DAY_SHORT_NAMES } from './constants';

export default function shmoment(
  dateString?: number | string | Date | Shmoment
): Shmoment {
  let dated: Date = new Date();
  if (
    typeof dateString === 'string' ||
    typeof dateString === 'number' ||
    dateString instanceof Date
  ) {
    dated = new Date(dateString);
  } else if (dateString && dateString.dated) {
    dated = new Date(dateString.dated);
  }
  const invalidDate = dated instanceof Date && isNaN(dated.getDate());

  const add = (amount: number, type: string) => {
    const current = {
      year: dated.getFullYear(),
      month: dated.getMonth(),
      date: dated.getDate()
    };

    switch (type) {
      case 'year':
        dated.setFullYear(current.year + amount);
        break;
      case 'month':
        dated.setMonth(current.month + amount);
        break;
      case 'date':
        dated.setDate(current.date + amount);
        break;
      default:
        break;
    }

    return shmoment(dated);
  };

  const subtract = (amount: number, type: string) => {
    const current = {
      year: dated.getFullYear(),
      month: dated.getMonth(),
      date: dated.getDate()
    };

    switch (type) {
      case 'year':
        dated.setFullYear(current.year - amount);
        break;
      case 'month':
        dated.setMonth(current.month - amount);
        break;
      case 'date':
        dated.setDate(current.date - amount);
        break;
      default:
        break;
    }

    return shmoment(dated);
  };

  const day = (dayToSet: number) => {
    const currentDay = dated.getDay();
    const currentDate = dated.getDate();

    dated.setDate(currentDate + (dayToSet - currentDay));

    return shmoment(dated);
  };

  const date = (dayToSet: number) => {
    dated.setDate(dayToSet);

    return shmoment(dated);
  };

  const month = (monthToSet: number) => {
    dated.setMonth(monthToSet - 1);

    return shmoment(dated);
  };

  const year = (yearToSet: number) => {
    dated.setFullYear(yearToSet);

    return shmoment(dated);
  };

  const format = (format = 'YYYY-MM-DD') => {
    if (invalidDate) return 'Invalid Date';

    const fullYear = dated.getFullYear();
    const shortYear = fullYear.toString().substr(2, 2);
    const month = dated.getMonth();
    const monthFullName = MONTH_NAMES[month];
    const date = dated.getDate();
    const day = dated.getDay();
    const dayFullName = DAY_FULL_NAMES[day];
    const dayShortName = DAY_SHORT_NAMES[day];

    const twoNumberedDate = date < 10 ? `0${date}` : date;
    const twoNumberedMonth = 1 + month < 10 ? `0${1 + month}` : 1 + month;

    const matchObj: MatchObjType = {
      YYYY: fullYear.toString(),
      YY: shortYear,
      MMMM: monthFullName,
      MM: twoNumberedMonth.toString(),
      DD: twoNumberedDate.toString(),
      ddd: dayShortName,
      DDD: dayFullName
    };

    return format.replace(
      /YYYY|YY|MMMM|MM|DD|ddd|DDD/gi,
      matched => matchObj[matched]
    );
  };

  const get = (type: relatedAddGetTypes) => {
    switch (type) {
      case 'year':
        return dated.getFullYear();
      case 'month':
        return dated.getMonth() + 1;
      case 'date':
        return dated.getDate();
      case 'day':
        return dated.getDay();
    }
  };

  const daysInMonth = () => {
    return new Date(dated.getFullYear(), dated.getMonth() + 1, 0).getDate();
  };

  const startOf = (time: relatedStartTimeTypes) => {
    switch (time) {
      case 'year':
        dated.setMonth(0);
        break;
      case 'month':
        dated.setDate(1);
        break;
      case 'week':
        dated.setDate(dated.getDate() - dated.getDay() + 1);
        break;
      default:
        break;
    }

    return shmoment(dated);
  };

  const isToday = () => {
    return format() === shmoment().format();
  };

  return {
    isToday,
    startOf,
    dated,
    format,
    add,
    subtract,
    get,
    day,
    date,
    month,
    year,
    daysInMonth
  };
}
